import React from "react";

import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { Toaster } from "@shared/components/ui/Toaster";
import { ErrorView } from "@shared/components/error-view";
import { ResponsiveContextProvider } from "@shared/hooks/responsive/responsiveContext";
import { TooltipProvider } from "@shared/components/ui/Tooltip";
import { initTracking, Sentry } from "@shared/utils/init-tracking";

import { App } from "@/App.jsx";

import "./index.css";

const queryClient = new QueryClient();

initTracking();

ReactDOM.createRoot(document.getElementById("root")).render(
  <Sentry.ErrorBoundary
    fallback={ErrorView}
    onReset={() => {
      window.location.reload();
    }}
  >
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ResponsiveContextProvider>
          <TooltipProvider>
            <App />
            <Toaster />
          </TooltipProvider>
        </ResponsiveContextProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </Sentry.ErrorBoundary>
);
